import { Pagination } from 'components/Pagination'
import { PropertyCard } from 'components/Property'
import { ComponentType } from 'react'
import styled from 'styled-components'
import { GMap } from './g-map'

const Wrapper = styled.div`
  display: flex;
`

const Sidebar = styled.div`
  width: 530px;
  padding-top: 70px;
`

const Content = styled.div`
  flex: 1 1 auto;
`

const MapWrapper = styled.div`
  height: calc(100vh - 140px);
  position: sticky;
  top: 140px;
`

export const MapDesktop: ComponentType<{
  suptitle: string
  title: string
  properties: any[]
  total: number
  page: number
  limit: number
  loading: boolean
}> = ({ suptitle, title, properties, total, page, limit, loading }) => (
  <Wrapper>
    <Sidebar>
      <div className="py-40">
        <h1 className="mb-10 text-center font-size-14 font-weight-bold text-primary text-uppercase">{suptitle}</h1>
        <h2 className="mb-0 text-center font-family-serif font-weight-bold font-size-17">{title}</h2>
      </div>
      {properties.map((property) => (
        <div key={property.uuid} className="px-25 py-10">
          <PropertyCard property={property} horizontal />
        </div>
      ))}
      <Pagination total={total} limit={limit} page={page} loading={loading} className="pt-30 pb-40" />
      <div className="pt-20 pb-30 text-center font-size-14 text-gray-chateau">
        © {new Date().getFullYear()} Yucatán Premier
      </div>
    </Sidebar>
    <Content>
      <MapWrapper>
        <GMap properties={properties} />
      </MapWrapper>
    </Content>
  </Wrapper>
)
